// extracted by mini-css-extract-plugin
module.exports = {"header":"CategoryLevelHeader_header__QzhKe","headerContent":"CategoryLevelHeader_headerContent__LKolY","headerText":"CategoryLevelHeader_headerText__cXuQg"};